import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appPreventFirstSpace]'
})
export class PreventFirstSpaceDirective {

  constructor(private el: ElementRef) { 
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.el.nativeElement.selectionStart === 0 && event.key === ' ') {
      event.preventDefault();
    }
  }
  // @HostListener('input', ['$event'])
  // onInput(event:InputEvent ) {
  //   this.el.nativeElement.value=this.el.nativeElement.value.trimStart()
  //   event.preventDefault();
  // }

}
